(function () {
  'use strict';
  window.GDCartCoupon = function (cart) {
    var codes = (cart.discount_codes || []).filter(function (discount) {
      return discount.code && discount.applicable !== false;
    });
    var applications = (cart.cart_level_discount_applications || []).map(function (discount) {
      return { discount: discount, amount: Number(discount.total_allocated_amount || 0) };
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        applications.push({ discount: allocation.discount_application || {}, amount: Number(allocation.amount || 0) });
      });
    });
    var codeApplication = applications.find(function (entry) {
      return entry.discount.type === 'discount_code' && (entry.discount.code || entry.discount.title);
    });
    var code = codes.length ? codes[0].code : (codeApplication && (codeApplication.discount.code || codeApplication.discount.title));
    if (!code) return null;
    var amount = applications.reduce(function (total, entry) {
      var discount = entry.discount;
      var name = String(discount.code || discount.title || '');
      return discount.type === 'discount_code' && name.toLowerCase() === code.toLowerCase()
        ? total + entry.amount : total;
    }, 0);
    if (!amount && codes.length === 1 && !applications.some(function (entry) {
      var discount = entry.discount;
      return discount.type === 'discount_code'
        && String(discount.code || discount.title || '').toLowerCase() !== code.toLowerCase();
    })) {
      var otherDiscounts = applications.reduce(function (total, entry) {
        return entry.discount.type === 'discount_code' ? total : total + Math.max(0, entry.amount);
      }, 0);
      amount = Math.max(0, Number(cart.total_discount || 0) - otherDiscounts);
    }
    return { code: code, amount: Math.max(0, Math.min(amount, Number(cart.total_discount || 0))) };
  };
})();